import React, { FC } from 'react'
import { Card, CardInner } from 'components/Card/index'
import { CautionHeadline, Description } from 'components/Typography'
import { Spacer } from 'components/Utility'

type Props = {
  align?: 'center' | 'left' | 'right'
  caution: string
  description?: string
  size?: 'small' | 'medium' | 'large'
}

const CautionCard: FC<Props> = React.memo((props) => {
  const { align, caution, description, size = 'medium' } = props

  return (
    <Card>
      <CardInner>
        <CautionHeadline caution={caution} size={size} />
        {description && (
          <>
            <Spacer size={8} />
            <Description align={align} description={description} />
          </>
        )}
      </CardInner>
    </Card>
  )
})

export default CautionCard
